// Migrated 1:1 from @nexato/nx-core-module (lib/components/comments-icon.component.ts), #672.
import { Component, input, computed } from '@angular/core';

@Component({
    selector: 'app-comments-icon',
    template: `
        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.61,17.5H3.39c-1.59,0-2.89-1.3-2.89-2.89V3.39C.5,1.8,1.8.5,3.39.5h11.22c1.59,0,2.89,1.3,2.89,2.89v11.22c0,1.59-1.3,2.89-2.89,2.89ZM3.39,1.56c-1.01,0-1.83.82-1.83,1.83v11.22c0,1.01.82,1.83,1.83,1.83h11.22c1.01,0,1.83-.82,1.83-1.83V3.39c0-1.01-.82-1.83-1.83-1.83H3.39Z"/>
            <g>
                <path d="M12.39,7.2h-6.78c-.29,0-.53-.24-.53-.53s.24-.53.53-.53h6.78c.29,0,.53.24.53.53s-.24.53-.53.53Z"/>
                <path d="M12.39,9.53h-6.78c-.29,0-.53-.24-.53-.53s.24-.53.53-.53h6.78c.29,0,.53.24.53.53s-.24.53-.53.53Z"/>
                <path d="M8.53,11.86h-2.92c-.29,0-.53-.24-.53-.53s.24-.53.53-.53h2.92c.29,0,.53.24.53.53s-.24.53-.53.53Z"/>
            </g>
        </svg>
        @if (count() !== undefined) {
            <span>{{count()}}</span>
        }
    `,
    styles: [`
        :host {
            display: flex;
            float: left;
        }
        :host([hidden]) {
            display: none !important;
        }
        svg {
            height: 14px;
            margin-top: 3px;
            margin-right: 0.125rem;
        }
    `],
    host: {
        '[attr.hidden]': 'hidden()'
    }
})
export class CommentsIconComponent {

    count = input<number | undefined>();

    hidden = computed(() => !this.count() ? true : null);

}
